import { PartnerExtIdsModel } from '../../partner';
import { UserOwnerType } from '../constants';

export class UserOwner {
  id: number[];
  type: UserOwnerType;

  constructor(params?: Partial<UserOwner>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class UserOwnerReadModel {
  ownerId: number;
  ownerName: string;
  ownerType?: UserOwnerType;
  extIds?: PartnerExtIdsModel[];

  constructor(params?: UserOwnerReadModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class UserOwnerReadModelToPartnerSelection {
  id: number;
  name: string;
  extIds?: PartnerExtIdsModel[];

  constructor(params?: UserOwnerReadModel) {
    if (params) {
      this.id = params.ownerId;
      this.name = params.ownerName;
      this.extIds = params.extIds;
    }
  }
}

export class UserOwnerReadModelToUserOwner {
  id: number[];
  type: UserOwnerType;

  constructor(params?: UserOwnerReadModel[]) {
    if (params) {
      this.id = params.map((item: UserOwnerReadModel) => item.ownerId);
      this.type = params[0].ownerType;
    }
  }
}
